// componnet
import Acategory from "../components/category/category";
// react import
import { useState, useEffect, useContext } from "react";

export default function Category() {
  const [activeBtn, setActiveBtn] = useState(-1);
  return (
    <Acategory activeBtn={activeBtn} setActiveBtn={setActiveBtn}></Acategory>
  );
}
